import { get } from 'lodash'

export default function(fields = {}) {
  const secondaryPhone =
    get(fields, 'secondaryPhone', '') === '+'
      ? undefined
      : get(fields, 'secondaryPhone')

  return {
    ...fields,
    note: get(fields, 'participantDetail.note'),
    secondaryPhone,
    helpers: { withPostalAddress: Boolean(get(fields, 'postalAddress')) }
  }
}
